// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Ryk8","footer":"ModalUpdate_footer__BrUlZ"};